/* ==========================================================================
   PLEENA · Motor de scroll (GSAP + ScrollTrigger) con degradado seguro
   - Si GSAP no carga, todo queda visible y la galería funciona como slider
     nativo con swipe. Nada depende de que la animación exista.
   - Sin guardas de prefers-reduced-motion: las animaciones siempre corren.
   ========================================================================== */
(function () {
  if (window.__PLEENA_ENGINE__) return;
  window.__PLEENA_ENGINE__ = true;

  var GSAP_URL = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  var ST_URL = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';

  var gsapQ = [], gsapReady = false, gsapFailed = false;

  function onGsap(cb) {
    if (gsapReady) { try { cb(window.gsap, window.ScrollTrigger); } catch (e) { console.warn('[pleena]', e); } }
    else if (!gsapFailed) gsapQ.push(cb);
  }
  function flushGsap() {
    gsapReady = true;
    var list = gsapQ.splice(0);
    for (var i = 0; i < list.length; i++) { try { list[i](window.gsap, window.ScrollTrigger); } catch (e) { console.warn('[pleena]', e); } }
  }
  function loadScript(src, ok, fail) {
    var s = document.createElement('script');
    s.src = src; s.async = false; s.onload = ok; s.onerror = fail;
    document.head.appendChild(s);
  }
  function bootGsap() {
    if (window.gsap && window.ScrollTrigger) { window.gsap.registerPlugin(window.ScrollTrigger); return flushGsap(); }
    // theme Onnexa: GSAP local y compartido con motion.js (sin CDN, se baja una sola vez)
    if (window.ONX && window.ONX.gsap) {
      return window.ONX.gsap().then(flushGsap, function () { gsapFailed = true; gsapQ.length = 0; console.warn('[pleena] GSAP no cargó'); });
    }
    loadScript(GSAP_URL, function () {
      loadScript(ST_URL, function () {
        if (!window.gsap || !window.ScrollTrigger) { gsapFailed = true; gsapQ.length = 0; return; }
        window.gsap.registerPlugin(window.ScrollTrigger);
        flushGsap();
      }, function () { gsapFailed = true; gsapQ.length = 0; console.warn('[pleena] ScrollTrigger no cargó'); });
    }, function () { gsapFailed = true; gsapQ.length = 0; console.warn('[pleena] GSAP no cargó'); });
  }

  /* --------------------------------------------------------------- utilidad */
  // altura real disponible: descuenta anuncio + encabezado cuando la sección
  // es la primera de la página
  function cutFor(root) {
    var top = root.getBoundingClientRect().top + (window.pageYOffset || 0);
    return (top > 4 && top < window.innerHeight * 0.45) ? Math.round(top) : 0;
  }
  function autoCut(root, prop) {
    function fit() { root.style.setProperty(prop, cutFor(root) + 'px'); }
    fit();
    window.addEventListener('resize', fit, { passive: true });
    window.addEventListener('load', fit);
    return fit;
  }

  /* ---------------------------------------------------------------- reveals */
  var io = null;
  function ensureIO() {
    if (io || !('IntersectionObserver' in window)) return io;
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { entries[i].target.setAttribute('data-preveal-on', '1'); io.unobserve(entries[i].target); }
      }
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });
    return io;
  }
  function revealAll(root) {
    var els = (root || document).querySelectorAll('[data-preveal]:not([data-preveal-on])');
    if (!els.length) return;
    var obs = ensureIO();
    for (var i = 0; i < els.length; i++) {
      if (obs) obs.observe(els[i]); else els[i].setAttribute('data-preveal-on', '1');
    }
    setTimeout(function () {
      var pend = (root || document).querySelectorAll('[data-preveal]:not([data-preveal-on])');
      for (var j = 0; j < pend.length; j++) {
        var r = pend[j].getBoundingClientRect();
        if (r.top < window.innerHeight * 1.05 && r.bottom > -40) pend[j].setAttribute('data-preveal-on', '1');
      }
    }, 900);
  }

  /* ------------------------------------------------------------------- hero */
  function hero(root) {
    var media = root.querySelector('.plh__media');
    var panels = root.querySelectorAll('[data-plh-par]');
    if (!media && !panels.length) return;
    autoCut(root, '--plh-cut');
    onGsap(function (gsap) {
      var st = { trigger: root, start: 'top bottom', end: 'bottom top', scrub: 0.5 };
      /* el parallax se escribe DIRECTO en el elemento que se mueve. Antes iba como
         custom property en la seccion entera, y eso invalidaba el estilo de todo su
         interior (puntos, hebras, textos) en cada frame del scroll. */
      if (media) gsap.fromTo(media, { yPercent: -3 }, { yPercent: 4, ease: 'none', scrollTrigger: st });

      for (var i = 0; i < panels.length; i++) {
        (function (panel) {
          var st2 = { trigger: root, start: 'top bottom', end: 'bottom top', scrub: 0.6 };
          var amp = parseFloat(panel.getAttribute('data-plh-par')) || 0;

          var img = panel.querySelector('.plh__panel-img');
          if (img) gsap.fromTo(img, { yPercent: -amp / 2 }, { yPercent: amp / 2, ease: 'none', scrollTrigger: st2 });

          /* el contenido se va al REVÉS que su foto: al bajar, la imagen cae y el
             texto sube. Esa separación es lo que da la sensación de profundidad
             del hero de sofi.health. Se escribe directo en el elemento, nunca
             como custom property en la sección. */
          var txt = panel.querySelector('[data-plh-txt]');
          if (txt) gsap.fromTo(txt, { y: 0 }, { y: -amp * 1.7, ease: 'none', scrollTrigger: st2 });
        })(panels[i]);
      }
    });
  }

  /* Motor NATIVO de reserva para el hero 3D. Sin GSAP, sin ScrollTrigger: mide el
     progreso con getBoundingClientRect y escribe transform/opacity en rAF. Entra
     solo si GSAP no ha arrancado en 1.5s (bloqueado, sin red, CDN caído...), para
     que la escena nunca se quede muerta. Mismas fases que la timeline. */
  function hero3dNativo(root, el, col, debug) {
    var tick = false, ctrl = ('AbortController' in window) ? new AbortController() : null;
    root._plNativo = ctrl;

    function cl(v, a, b) { return v < a ? a : (v > b ? b : v); }
    function rgb(h) {
      h = String(h).replace('#', '').trim();
      if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
      var n = parseInt(h, 16);
      return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
    }
    function mix(a, b, k) {
      var x = rgb(a), y = rgb(b);
      return 'rgb(' + Math.round(x[0]+(y[0]-x[0])*k) + ',' +
                      Math.round(x[1]+(y[1]-x[1])*k) + ',' +
                      Math.round(x[2]+(y[2]-x[2])*k) + ')';
    }

    function pintar() {
      tick = false;
      var r = root.getBoundingClientRect();
      var recorrido = Math.max(root.offsetHeight - window.innerHeight, 1);
      var p = cl(-r.top / recorrido, 0, 1);
      var ancho = window.innerWidth, movil = ancho < 860;

      // fase 1 · profundidad  (0 → .30)
      var p1 = cl(p / 0.30, 0, 1);
      var gira = movil ? 0 : -8;
      if (el.model) el.model.style.transform =
        'translate3d(' + (ancho * 0.045 * p1) + 'px,0,' + (110 * p1) + 'px)' +
        ' rotateY(' + (gira * p1) + 'deg) scale(' + (1 + p1 * 0.04) + ')';
      if (el.info && !movil) el.info.style.transform =
        'translate3d(' + (-ancho * 0.035 * p1) + 'px,0,' + (-80 * p1) + 'px) rotateY(' + (7 * p1) + 'deg)';
      if (el.image) el.image.style.transform =
        'translate3d(0,' + (-3 * p1) + '%,0) scale(' + (1 + p1 * 0.13) + ')';

      // color 1 · hacia el intermedio
      var c = p < 0.46 ? mix(col.start, col.mid, cl(p / 0.46, 0, 1)) : col.mid;

      // fase 2 · invasión  (.30 → .67)
      var p2 = cl((p - 0.30) / 0.37, 0, 1);
      if (p2 > 0) {
        if (el.model) el.model.style.transform =
          'translate3d(' + (ancho * (0.045 + p2 * 0.145)) + 'px,0,' + (110 + p2 * 80) + 'px)' +
          ' rotateY(' + (gira + (-gira) * p2) + 'deg) scale(' + (1.04 + p2 * 0.16) + ')';
        if (el.infoCpy) {
          el.infoCpy.style.opacity = String(1 - p2);
          el.infoCpy.style.transform = 'translate3d(' + (p2 * 80) + 'px,' + (-p2 * 30) + 'px,0)';
        }
      }

      // fase 3 · cierre  (.62 → 1)
      var p3 = cl((p - 0.62) / 0.38, 0, 1);
      if (p3 > 0) {
        c = mix(col.mid, col.end, p3);
        if (el.model)   el.model.style.opacity   = String(1 - p3 * 0.78);
        if (el.modelCpy) el.modelCpy.style.opacity = String(cl(1 - p3 * 1.6, 0, 1));
        var sale = cl((p3 - 0.15) / 0.55, 0, 1);
        if (el.final) {
          el.final.style.opacity = String(sale);
          el.final.style.transform =
            'translate3d(0,' + ((1 - sale) * 50) + 'px,' + ((1 - sale) * 220) + 'px) scale(' + (0.84 + sale * 0.16) + ')';
          if (sale > 0.85) el.final.classList.add('is-on'); else el.final.classList.remove('is-on');
        }
      } else if (el.final) {
        el.final.style.opacity = '0';
        el.final.classList.remove('is-on');
      }

      root.style.backgroundColor = c;
      if (el.info) el.info.style.backgroundColor = c;
    }

    function pedir() { if (!tick) { tick = true; requestAnimationFrame(pintar); } }
    var op = ctrl ? { passive: true, signal: ctrl.signal } : { passive: true };
    window.addEventListener('scroll', pedir, op);
    window.addEventListener('resize', pedir, op);
    pintar();
    if (debug) console.info('[pleena 3D] motor NATIVO en marcha (sin GSAP)');
  }

  /* Panel de diagnóstico VISIBLE en la página. La consola no siempre está a mano:
     con esto basta una captura para saber qué motor corre y si hay recorrido. */
  function p3dPanel(root) {
    var box = document.createElement('div');
    box.setAttribute('style', [
      'position:fixed','left:10px','bottom:10px','z-index:99999',
      'background:rgba(10,8,6,.92)','color:#9EF3C4','font:12px/1.5 ui-monospace,Menlo,monospace',
      'padding:10px 12px','border-radius:8px','max-width:min(92vw,440px)',
      'white-space:pre-wrap','pointer-events:none'
    ].join(';'));
    document.body.appendChild(box);

    var culpable = null, a = root.querySelector('.p3d__sticky');
    a = a && a.parentElement;
    while (a && a !== document.body) {
      var ov = getComputedStyle(a).overflow;
      if (/hidden|auto|scroll/.test(ov)) { culpable = (a.tagName + '.' + (a.className || '').split(' ')[0]); break; }
      a = a.parentElement;
    }

    var stickyOk = getComputedStyle(root.querySelector('.p3d__sticky')).position;

    function linea() {
      var r = root.getBoundingClientRect();
      var recorrido = root.offsetHeight - window.innerHeight;
      var prog = Math.max(0, Math.min(1, -r.top / Math.max(recorrido, 1)));
      var SALTO = String.fromCharCode(10);
      box.textContent = [
        "PLEENA 3D · diagnóstico",
        "motor        : " + (root._plMotor || "ninguno todavía"),
        "gsap         : " + (typeof window.gsap) + "   ScrollTrigger: " + (typeof window.ScrollTrigger),
        "menos movim. : " + !!(window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches),
        "alto sección : " + root.offsetHeight + "px   ventana: " + window.innerHeight + "px",
        "recorrido    : " + recorrido + "px" + (recorrido < 50 ? "   <-- SIN RECORRIDO" : ""),
        "sticky       : " + stickyOk + (stickyOk.indexOf("sticky") < 0 ? "   <-- NO ES STICKY" : ""),
        "lo rompe     : " + (culpable || "nada"),
        "progreso     : " + prog.toFixed(3)
      ].join(SALTO);
      requestAnimationFrame(linea);
    }
    linea();
  }

  /* ------------------------------------------------------------- icono 3D */
  /* Las líneas cruzan la pantalla alternando lado, convergen al centro, de ahí
     nace el logo y al final entra el catálogo. Todo tipografía y SVG. */
  function icono3d(root) {
    var lines = root.querySelector('[data-pic-lines]');
    var logo  = root.querySelector('[data-pic-logo]');
    var end   = root.querySelector('[data-pic-end]');
    var dark  = root.querySelector('[data-pic-dark]');
    if (!lines || !logo) return;

    var rows = lines.querySelectorAll('.pic__row');
    var svg  = logo.querySelector('.pic__svg');
    var ring = logo.querySelector('.pic__ring');
    var rin2 = logo.querySelector('.pic__ring2');
    var eL   = logo.querySelector('.pic__eL');
    var eR   = logo.querySelector('.pic__eR');
    var bar  = logo.querySelector('.pic__bar');

    var cs  = getComputedStyle(root);
    var bg1 = cs.getPropertyValue('--pic-bg').trim()  || '#FFFFFF';
    var bg2 = cs.getPropertyValue('--pic-bg2').trim() || '#2B211B';

    onGsap(function (gsap) {
      if (!window.ScrollTrigger) return;
      gsap.registerPlugin(ScrollTrigger);
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      var K = (reduce && !root.hasAttribute('data-pic-force')) ? 0 : 1;

      /* estado de partida: cada línea espera fuera de su lado */
      for (var i = 0; i < rows.length; i++) {
        var der = rows[i].getAttribute('data-dir') === 'r';
        gsap.set(rows[i], { xPercent: (der ? 120 : -120) * K, opacity: K ? 0 : 1 });
      }
      gsap.set(logo, { opacity: 0, scale: 0.25, rotateY: -60 });
      gsap.set(end,  { opacity: 0, y: 30 });

      var tl = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: {
          trigger: root, start: 'top 70%', end: 'bottom bottom',
          scrub: 1, invalidateOnRefresh: true
        }
      });

      /* ---- 1 · CRUZAN, cada una a su ritmo y por su lado ---- */
      for (var j = 0; j < rows.length; j++) {
        var d2 = rows[j].getAttribute('data-dir') === 'r';
        var cuando = j * 0.05;                       // escalonadas
        tl.to(rows[j], { xPercent: 0, opacity: 1, duration: 0.18 }, cuando)
          .to(rows[j], { xPercent: (d2 ? -120 : 120) * K, opacity: 0, duration: 0.20 }, 0.30 + cuando);
      }

      /* ---- 2 · CONVERGEN: el bloque entero se cierra hacia el centro ---- */
      tl.to(lines, { scale: 0.2 * K + (K ? 0 : 1), opacity: 0, duration: 0.16 }, 0.44)
        .to(dark || root, dark ? { clipPath: 'circle(78% at 50% 52%)', duration: 0.22, ease: 'power2.in' } : { backgroundColor: bg2, duration: 0.24 }, 0.42)
        .to({}, { duration: 0.24,
                     onStart: function () { root.classList.add('is-dark'); },
                     onReverseComplete: function () { root.classList.remove('is-dark'); } }, 0.42);

      /* ---- 3 · NACE EL LOGO desde ese mismo punto ---- */
      /* fromTo EXPLÍCITO, no from(): con scrub, .from() no garantiza el estado
         final y las piezas se quedaban invisibles — el logo salía como un aro
         vacío. Aquí cada trazo dice de dónde sale y dónde acaba. */
      tl.to(logo, { opacity: 1, scale: 1, rotateY: 0, duration: 0.22 }, 0.52)
        .fromTo(eL,   { xPercent: -70 * K, opacity: 0 },
                      { xPercent: 0, opacity: 1, duration: 0.14, immediateRender: false }, 0.56)
        .fromTo(eR,   { xPercent: 70 * K,  opacity: 0 },
                      { xPercent: 0, opacity: 1, duration: 0.14, immediateRender: false }, 0.58)
        .fromTo(bar,  { scaleX: 0, opacity: 0 },
                      { scaleX: 1, opacity: 1, duration: 0.12, immediateRender: false }, 0.62)
        .fromTo(ring, { scale: 1.7, opacity: 0 },
                      { scale: 1, opacity: 1, duration: 0.16, immediateRender: false }, 0.54)
        ;

      /* el logo gira en 3D mientras se muestra */
      tl.to(svg, { rotateY: 22 * K, rotateX: -8 * K, duration: 0.16 }, 0.70)
        .to(svg, { rotateY: 0, rotateX: 0, scale: 1 + 0.10 * K, duration: 0.14 }, 0.82);

      /* ---- 4 · EL CATÁLOGO ---- */
      /* seguro: pase lo que pase con el scrub, al final el logo está entero */
      tl.set([eL, eR, bar, ring], { opacity: 1, xPercent: 0, scaleX: 1, scale: 1 }, 0.80);
      tl.to(logo, { scale: 0.74, duration: 0.12 }, 0.84)
        .to(end,  { opacity: 1, y: 0, duration: 0.12 }, 0.86);

      /* NUNCA un giro de 360°: media vuelta el logo se ve de canto y queda como
         un óvalo aplastado. Una oscilación corta da volumen y siempre se lee. */
      if (K) gsap.to(svg, { rotateY: 18, duration: 6, ease: 'sine.inOut',
                            repeat: -1, yoyo: true, startAt: { rotateY: -18 } });

      document.addEventListener('shopify:section:unload', function (e) {
        if (e.target && e.target.contains(root) && tl.scrollTrigger) tl.scrollTrigger.kill();
      });
    });
  }

  /* -------------------------------------------------------------- hero 3D */
  /* Timeline continua ligada al scroll, con las posiciones del plan:
     0 → .25 profundidad · .25 → .55 invasión + color · .55 → .75 foco ·
     .70 → 1 cierre Pleena. En móvil (matchMedia) se cae a zoom + un color. */
  function hero3d(root) {
    var sticky = root.querySelector('.p3d__sticky');
    if (!sticky) return;
    var model    = root.querySelector('.p3d__panel--model');
    var info     = root.querySelector('.p3d__panel--info');
    var image    = root.querySelector('.p3d__image') || root.querySelector('.p3d__fallback');
    var modelCpy = root.querySelector('.p3d__model-copy');
    var infoCpy  = root.querySelector('.p3d__info-copy');
    var final    = root.querySelector('.p3d__final');
    var estrella = root.querySelector('[data-p3d-star]');
    var sRing = estrella && estrella.querySelector('.pl-logo__ring');
    var sEL   = estrella && estrella.querySelector('.pl-logo__eL');
    var sER   = estrella && estrella.querySelector('.pl-logo__eR');
    var sBar  = estrella && estrella.querySelector('.pl-logo__bar');
    var sSvg  = estrella && estrella.querySelector('.pl-logo__svg');

    var cs = getComputedStyle(root);
    var colStart = cs.getPropertyValue('--p3d-start').trim() || '#C9A08F';
    var colMid   = cs.getPropertyValue('--p3d-mid').trim()   || '#E9D9CF';
    var colEnd   = cs.getPropertyValue('--p3d-end').trim()   || '#2B211B';

    /* el fallo clásico de una escena sticky es que un ANCESTRO tenga overflow
       hidden/auto/scroll: eso lo convierte en contenedor de scroll y el sticky
       deja de pegarse. (overflow:clip NO lo rompe; es la excepción.) */
    if (root.hasAttribute('data-p3d-debug')) {
      var a = sticky.parentElement, culpable = null;
      while (a && a !== document.body) {
        var ov = getComputedStyle(a).overflow;
        if (/hidden|auto|scroll/.test(ov)) { culpable = a; break; }
        a = a.parentElement;
      }
      console[culpable ? 'error' : 'info']('[pleena 3D] ancestro que rompe el sticky:',
        culpable || 'ninguno, el sticky puede pegarse');
    }

    var els  = { model: model, info: info, image: image, modelCpy: modelCpy, infoCpy: infoCpy, final: final };
    var cols = { start: colStart, mid: colMid, end: colEnd };
    var dbg  = root.hasAttribute('data-p3d-debug');
    var conGsap = false;
    if (dbg) p3dPanel(root);

    /* RELEVO: si GSAP no ha arrancado en 1.5s (CDN bloqueado, sin red, un
       bloqueador de scripts...), el motor nativo se hace cargo. La escena no se
       queda muerta por depender de una librería externa. */
    setTimeout(function () {
      if (!conGsap && !root._plNativo) { root._plMotor = 'NATIVO (sin GSAP)'; hero3dNativo(root, els, cols, dbg); }
    }, 1500);

    onGsap(function (gsap) {
      if (!window.ScrollTrigger) {
        if (dbg) console.warn('[pleena 3D] ScrollTrigger no cargó: paso al motor nativo');
        if (!root._plNativo) { root._plMotor = 'NATIVO (falta ScrollTrigger)'; hero3dNativo(root, els, cols, dbg); }
        return;
      }
      conGsap = true;
      root._plMotor = 'GSAP';
      if (root._plNativo) { root._plNativo.abort(); root._plNativo = null; }
      gsap.registerPlugin(ScrollTrigger);

      var mm = gsap.matchMedia();
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      
      var titulo = root.querySelector('.p3d__title');
      if (dbg) console.info('[pleena 3D] motor GSAP · gsap', typeof gsap, '· ScrollTrigger',
        typeof window.ScrollTrigger, '· reduced-motion', reduce, '· ancho', innerWidth);

      /* sin animación: la escena se ve entera y quieta, y se sale */
      /* "Reducir movimiento" NO debe dejar la escena muerta. La recomendación de
         accesibilidad es ATENUAR: fuera rotaciones 3D y parallax fuerte, se quedan
         el cambio de color y los fundidos, que no marean. El ajuste "Ignorar
         'reducir movimiento'" del editor lo salta por completo. */
      var forzar = root.hasAttribute('data-p3d-force');
      var suave = reduce && !forzar;
      if (suave) root._plMotor = 'GSAP suave (menos movimiento)';
      if (dbg && suave) console.info('[pleena 3D] menos movimiento: versión atenuada');

      /* ---------------- escritorio: la escena completa ---------------- */
      var K = suave ? 0 : 1;            // intensidad del movimiento
      mm.add('(min-width: 860px)', function () {
        var tl = gsap.timeline({
          defaults: { ease: 'none' },
          scrollTrigger: {
            trigger: root, start: 'top top', end: 'bottom bottom',
            scrub: 1, invalidateOnRefresh: true, markers: dbg,
            onEnter: function () { if (dbg) console.info('[pleena 3D] escena EN MARCHA (escritorio)'); }
          }
        });

        // 0 → 25%  profundidad: los paneles se separan en Z y giran apenas
        tl.to(model, { xPercent: 12 * K, rotationY: -11 * K, z: 160 * K, transformOrigin: '50% 50%' }, 0)
          .to(info,  { xPercent: -8 * K, rotationY: 12 * K, z: -130 * K, transformOrigin: '50% 50%' }, 0)
          .to(image, { scale: 1 + 0.18 * K, yPercent: -6 * K }, 0);
        if (titulo) tl.to(titulo, { z: 90 * K, scale: 1 + 0.04 * K }, 0);

        /* ---- coreografía del símbolo, si él es el protagonista ----
           Cada tramo hace algo distinto: gira, se abre, las piezas vuelan y
           vuelven a juntarse. Es lo que la foto no puede hacer. */
        if (estrella) {
          estrella.parentElement.classList.add('is-on');           // arranca el trazado
          var lg = estrella.querySelector('.pl-logo');
          if (lg) lg.classList.add('is-on');

          // 0 → .25  el símbolo gira y se acerca
          tl.to(sSvg,  { rotateY: 18 * K, rotateX: -8 * K, scale: 1 + 0.18 * K }, 0)
            .to(sRing, { rotate: 60 * K, scale: 1 + 0.10 * K }, 0);

          // .25 → .55  se ABRE: las dos «e» se separan y la barra se estira
          tl.to(sEL,  { xPercent: -46 * K, rotate: -16 * K }, 0.25)
            .to(sER,  { xPercent: 46 * K,  rotate: 16 * K },  0.25)
            .to(sBar, { scaleX: 1 + 0.55 * K, opacity: 0.45 }, 0.25)
            .to(sRing,{ rotate: 190 * K, scale: 1 + 0.42 * K, opacity: 0.30 }, 0.28)
            .to(sSvg, { rotateY: -14 * K, scale: 1 + 0.42 * K }, 0.30);

          // .55 → .78  las piezas vuelven y el símbolo se rearma, más grande
          tl.to([sEL, sER], { xPercent: 0, rotate: 0 }, 0.55)
            .to(sBar,  { scaleX: 1, opacity: 1 }, 0.58)
            .to(sRing, { rotate: 360 * K, scale: 1, opacity: 0.55 }, 0.55)
            .to(sSvg,  { rotateY: 0, rotateX: 0, scale: 1 + 0.62 * K }, 0.58);

          // .78 → 1  se retira para dejar paso al cierre
          tl.to(estrella, { autoAlpha: 0, scale: 1 + 1.1 * K }, 0.78);
        }

        // 25 → 55%  la modelo invade el panel derecho y el fondo aclara
        tl.to(model,   { xPercent: 28 * K, z: 260 * K, scale: 1 + 0.10 * K }, 0.25)
          .to(root,    { backgroundColor: colMid }, 0.30)
          .to(infoCpy, { autoAlpha: 0, xPercent: 34 * K, z: 120 * K }, 0.36)
          .to(info, { xPercent: -26 * K, z: -220 * K, scale: 1 - 0.14 * K }, 0.34);

        // 55 → 75%  la foto domina y su texto se retira
        tl.to(model,    { xPercent: 0, rotationY: 0, scale: 1 + 0.20 * K }, 0.55)
          .to(modelCpy, { autoAlpha: 0, yPercent: -34 * K, z: 200 * K }, 0.62);

        // 70 → 100%  cierre Pleena, naciendo desde el fondo
        tl.to(root,  { backgroundColor: colEnd }, 0.70)
          .to(model, { autoAlpha: 0, scale: 1 + 0.34 * K }, 0.70)
          .fromTo(final, { autoAlpha: 0, scale: 1 - 0.2 * K, z: 240 * K },
                         { autoAlpha: 1, scale: 1, z: 0, onStart: function () { final.classList.add('is-on'); var lg = final.querySelector('.pl-logo'); if (lg) lg.classList.add('is-on'); } }, 0.74);

        return function () { gsap.set([model, info, image, modelCpy, infoCpy, final], { clearProps: 'all' }); };
      });

      /* ------- móvil: zoom + parallax + UN cambio de color, sin giro ------- */
      mm.add('(max-width: 859px)', function () {
        var tl = gsap.timeline({
          defaults: { ease: 'none' },
          scrollTrigger: {
            trigger: root, start: 'top top', end: 'bottom bottom',
            scrub: 0.8, invalidateOnRefresh: true, markers: dbg,
            onEnter: function () { if (dbg) console.info('[pleena 3D] escena EN MARCHA (móvil)'); }
          }
        });
        /* En móvil no hay giro 3D (caro y marea), pero SÍ tiene que pasar algo en
           cada tramo: la foto se acerca y sube, el titular se va, el panel de
           texto se desliza fuera, el color vira y el cierre nace. Antes solo
           había zoom y por eso "solo se acercaba la chica". */
        tl.to(image,   { scale: 1 + 0.26 * K, yPercent: -10 * K }, 0)
          .to(modelCpy,{ y: -26 * K, scale: 1 + 0.05 * K }, 0)
          .to(root,    { backgroundColor: colMid }, 0.16);

        if (titulo) tl.to(titulo, { letterSpacing: '-0.005em' }, 0);

        if (estrella) {
          estrella.parentElement.classList.add('is-on');
          var lgm = estrella.querySelector('.pl-logo');
          if (lgm) lgm.classList.add('is-on');
          tl.to(sSvg,  { scale: 1 + 0.22 * K }, 0)
            .to(sRing, { rotate: 120 * K }, 0)
            .to(sEL,   { xPercent: -38 * K }, 0.28)
            .to(sER,   { xPercent: 38 * K },  0.28)
            .to(sBar,  { scaleX: 1 + 0.4 * K, opacity: 0.5 }, 0.28)
            .to(sRing, { rotate: 300 * K, scale: 1 + 0.3 * K, opacity: 0.35 }, 0.30)
            .to([sEL, sER], { xPercent: 0 }, 0.54)
            .to(sBar,  { scaleX: 1, opacity: 1 }, 0.56)
            .to(sRing, { rotate: 360 * K, scale: 1, opacity: 0.55 }, 0.54)
            .to(sSvg,  { scale: 1 + 0.55 * K }, 0.56)
            .to(estrella, { autoAlpha: 0, scale: 1 + 0.9 * K }, 0.72);
        }

        tl.to(infoCpy, { autoAlpha: 0, y: 56 * K, scale: 1 - 0.06 * K }, 0.30)
          .to(image,   { scale: 1 + 0.40 * K, yPercent: -16 * K }, 0.34)
          .to(modelCpy,{ autoAlpha: 0, y: -80 * K, scale: 1 + 0.14 * K }, 0.46)
          .to(root,    { backgroundColor: colEnd }, 0.56)
          .to(model,   { autoAlpha: 0, scale: 1 + 0.5 * K }, 0.60)
          .fromTo(final, { autoAlpha: 0, scale: 1 - 0.18 * K, y: 40 * K },
                         { autoAlpha: 1, scale: 1, y: 0,
                           onStart: function () { final.classList.add('is-on'); var lg = final.querySelector('.pl-logo'); if (lg) lg.classList.add('is-on'); } }, 0.64);

        return function () { gsap.set([model, image, modelCpy, infoCpy, final], { clearProps: 'all' }); };
      });

      /* el editor de temas recarga secciones: hay que matar lo anterior */
      document.addEventListener('shopify:section:unload', function (e) {
        if (e.target && e.target.contains(root)) mm.revert();
      });
    });
  }

  /* ---------------------------------------------------------- symbol story */
  function symbol(root) {
    var track = root.querySelector('.psym__track');
    var stage = root.querySelector('.psym__stage');
    var inner = root.querySelector('.psym__inner');
    var mark = root.querySelector('.psym__mark');
    var ring = root.querySelector('.psym__ring');
    var bar = root.querySelector('.psym__bar');
    /* la barrita de progreso es la unica que usa --psym-p. Escribirla en
       .psym__stage invalidaba el estilo de todo su subarbol (deco + fx + 66
       puntos) en CADA frame del scroll: eso era lo que trababa iOS. */
    var prog = root.querySelector('.psym__progress') || root.querySelector('.psym__progress i');
    var eL = root.querySelector('.psym__eL');
    var eR = root.querySelector('.psym__eR');
    var word = root.querySelector('.psym__word');
    var claim = root.querySelector('.psym__claim');
    var tag = root.querySelector('.psym__tag');
    var cue = root.querySelector('.psym__cue');
    if (!track || !stage || !mark) return;

    autoCut(root, '--psym-cut');

    onGsap(function (gsap, ST) {
      stage.classList.add('is-live');
      var isText = word && !word.querySelector('img');

      // El trazo se dibuja al cargar con animación CSS (`.is-live`), no con
      // GSAP: una animación CSS siempre termina en su estado final aunque el
      // navegador congele los frames.
      gsap.set(mark, { opacity: 1, scale: 1, transformOrigin: '50% 50%' });
      gsap.set(ring, { opacity: 0.55, transformOrigin: '50% 50%' });

      // --- recorrido con el scroll ------------------------------------------
      var wordFrom = { opacity: 0, scale: 0.93 };
      if (isText) wordFrom.letterSpacing = '0.42em';
      gsap.set(word, wordFrom);
      gsap.set([tag, claim], { opacity: 0, y: 24 });
      gsap.set([eL, eR], { xPercent: 0, rotate: 0 });
      gsap.set(bar, { scaleX: 1 });

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: track, start: 'top top', end: 'bottom bottom', scrub: 0.7,
          invalidateOnRefresh: true,
          onUpdate: function (self) { if (prog) prog.style.setProperty('--psym-p', self.progress.toFixed(2)); }
        }
      });

      if (cue) tl.to(cue, { opacity: 0, duration: 0.08 }, 0.04);

      tl.to(bar, { scaleX: 0, duration: 0.20, ease: 'power2.inOut' }, 0.10)
        .to(eL, { xPercent: -132, rotate: -14, duration: 0.32, ease: 'power2.inOut' }, 0.18)
        .to(eR, { xPercent: 132, rotate: 14, duration: 0.32, ease: 'power2.inOut' }, 0.18)
        .to(ring, { scale: 2.2, opacity: 0, duration: 0.32, ease: 'power1.in' }, 0.20)
        .to(mark, { opacity: 0, duration: 0.14, ease: 'none' }, 0.44)
        .to(word, isText
          ? { opacity: 1, scale: 1, letterSpacing: '-0.03em', duration: 0.32, ease: 'power2.out' }
          : { opacity: 1, scale: 1, duration: 0.32, ease: 'power2.out' }, 0.38)
        .to(tag, { opacity: 1, y: 0, duration: 0.14 }, 0.62)
        .to(claim, { opacity: 1, y: 0, duration: 0.18 }, 0.68)
        .to(inner, { y: -36, duration: 0.14, ease: 'power1.in' }, 0.86);

      if (ST) ST.refresh();
    });
  }

  /* -------------------------------------------------------- sticky gallery */
  function gallery(root) {
    var track = root.querySelector('.pgal__track');
    var stage = root.querySelector('.pgal__stage');
    var rail = root.querySelector('.pgal__rail');
    var bar = root.querySelector('.pgal__bar');
    var cur = root.querySelector('.pgal__cur');
    var cards = root.querySelectorAll('.pgal__card');
    if (!track || !rail || cards.length < 2) return;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    rail.addEventListener('scroll', function () {
      if (root.classList.contains('pgal--live')) return;
      var max = rail.scrollWidth - rail.clientWidth;
      var p = max > 0 ? rail.scrollLeft / max : 0;
      if (bar) bar.style.setProperty('--pgal-p', p.toFixed(2));
      if (cur) cur.textContent = pad(Math.min(cards.length, Math.round(p * (cards.length - 1)) + 1));
    }, { passive: true });

    onGsap(function (gsap, ST) {
      root.classList.add('pgal--live');

      // La distancia se recalcula y se guarda: el recorrido se escribe en cada
      // frame con el valor vigente, nunca con uno cacheado al crear el tween.
      var DIST = 0, RAIL0 = 0, GEO = [];
      function layout() {
        DIST = Math.max(0, rail.scrollWidth - root.clientWidth);
        track.style.height = (stage.offsetHeight + DIST) + 'px';
        // geometría en reposo: así el pintado de cada frame no lee el layout
        var cx = 0;
        try { cx = parseFloat(gsap.getProperty(rail, 'x')) || 0; } catch (e) {}
        var rr = rail.getBoundingClientRect();
        RAIL0 = rr.left - cx;
        GEO = [];
        for (var i = 0; i < cards.length; i++) {
          var r = cards[i].getBoundingClientRect();
          GEO.push({ x: r.left - rr.left, w: r.width });
        }
      }
      layout();

      // opacidad y desplazamiento de cada tarjeta según dónde está en pantalla
      function paint(p) {
        var vw = window.innerWidth;
        for (var i = 0; i < GEO.length; i++) {
          var centro = RAIL0 + GEO[i].x + GEO[i].w / 2 - DIST * p;
          var t = (vw + GEO[i].w * 0.30 - centro) / (vw * 0.62);
          t = t < 0 ? 0 : (t > 1 ? 1 : t);
          var e = t * t * (3 - 2 * t);
          cards[i].style.opacity = (0.05 + 0.95 * e).toFixed(3);
          cards[i].style.transform = 'translate3d(0,' + ((1 - e) * 38).toFixed(1) + 'px,0) scale(' + (0.92 + 0.08 * e).toFixed(3) + ')';
        }
      }

      var setX = gsap.quickSetter(rail, 'x', 'px');
      var proxy = { p: 0 };
      setX(0);
      paint(0);
      if (bar) bar.style.setProperty('--pgal-p', '0');

      gsap.to(proxy, {
        p: 1, ease: 'none',
        onUpdate: function () {
          setX(-DIST * proxy.p);
          paint(proxy.p);
          if (bar) bar.style.setProperty('--pgal-p', proxy.p.toFixed(2));
          if (cur) cur.textContent = pad(Math.min(cards.length, Math.floor(proxy.p * cards.length) + 1));
        },
        scrollTrigger: {
          trigger: track, start: 'top top', end: 'bottom bottom', scrub: 0.6,
          invalidateOnRefresh: true, onRefresh: layout
        }
      });

      var rt;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () { layout(); paint(proxy.p); if (ST) ST.refresh(); }, 160);
      }, { passive: true });
      window.addEventListener('load', function () { layout(); paint(proxy.p); if (ST) ST.refresh(); });
      if (ST) ST.refresh();
    });
  }

  /* ----------------------------------------------------------------- ritual */
  function ritual(root) {
    var steps = root.querySelector('.prit__steps');
    if (!steps) return;
    onGsap(function (gsap) {
      gsap.fromTo(root, { '--prit-line': 0 }, {
        '--prit-line': 1, ease: 'none',
        scrollTrigger: { trigger: steps, start: 'top 82%', end: 'bottom 70%', scrub: 0.5 }
      });
    });
  }

  /* --------------------------------------------------------------- reseñas */
  function timeline(root) {
    var track = root.querySelector('.ptl__track');
    var stage = root.querySelector('.ptl__stage');
    var revs = root.querySelectorAll('.ptl__rev');
    var dots = root.querySelectorAll('.ptl__rail i');
    if (!track || !stage || !revs.length) return;

    onGsap(function (gsap, ST) {
      stage.classList.add('is-live');
      var n = revs.length, activo = -1;

      // MAZO DE CARTAS: la de arriba sale volando y la siguiente ya está debajo.
      // Las tarjetas son opacas y van apiladas por z-index, así que dos textos
      // nunca se ven encimados (el fade cruzado de antes los mezclaba al 50%).
      var suave = function (t) { t = t < 0 ? 0 : (t > 1 ? 1 : t); return t * t * (3 - 2 * t); };
      function pintar(p) {
        var pos = p * n;                                   // 0 → n
        for (var i = 0; i < n; i++) {
          var local = pos - i;                             // <0 espera · 0..1 arriba · >1 ya salió
          var r = revs[i], st = r.style, ty = 0, rot = 0, sc = 1, op = 1;
          if (local < 0) {                                 // en el mazo, detrás
            var prof = Math.min(-local, 3);
            ty = prof * 16; sc = 1 - prof * 0.05; op = prof > 2.6 ? 0 : 1;
          } else if (local < 1 || i === n - 1) {           // arriba (la última no se va)
            var t = i === n - 1 ? 0 : suave((local - 0.62) / 0.38);
            ty = -t * 120; rot = -7 * t; sc = 1 - t * 0.04; op = 1 - t;
          } else { op = 0; }
          st.zIndex = String(100 - i);
          st.opacity = op.toFixed(3);
          st.transform = 'translateY(calc(-50% + ' + ty.toFixed(1) + 'px)) rotate(' + rot.toFixed(2) + 'deg) scale(' + sc.toFixed(3) + ')';
          st.pointerEvents = (local >= 0 && local < 0.62) || (i === n - 1 && local >= 0) ? 'auto' : 'none';
        }
        var idx = Math.min(n - 1, Math.max(0, Math.floor(pos)));
        if (idx !== activo) {
          activo = idx;
          for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-on', j === idx);
          entra(revs[idx]);
        }
      }

      // Al llegar arriba: palabras y estrellas con anime.js (elementos internos,
      // GSAP solo mueve la tarjeta: nunca dos motores sobre lo mismo)
      function entra(rev) {
        var A = window.anime;
        if (!A || !rev) return;
        var palabras = rev.querySelectorAll('.ptl__w');
        var estrellas = rev.querySelectorAll('.ptl__star');
        if (palabras.length) A.animate(palabras, { opacity: [0, 1], y: [10, 0], duration: 520, delay: A.stagger(28), ease: 'outQuad' });
        if (estrellas.length) A.animate(estrellas, { scale: [0.3, 1], opacity: [0, 1], duration: 620, delay: A.stagger(70, { start: 120 }), ease: 'outBack(2)' });
      }
      pintar(0);

      var proxy = { p: 0 };
      gsap.to(proxy, {
        p: 1, ease: 'none',
        onUpdate: function () { pintar(proxy.p); },
        scrollTrigger: { trigger: track, start: 'top top', end: 'bottom bottom', scrub: 0.5, invalidateOnRefresh: true }
      });

      // el mechón se dibuja a lo largo de todo el recorrido
      gsap.fromTo(root, { '--ptl-draw': 0 }, {
        '--ptl-draw': 1, ease: 'none',
        scrollTrigger: { trigger: track, start: 'top top', end: 'bottom bottom', scrub: 0.4 }
      });

      if (ST) ST.refresh();
    });
  }

  /* ----------------------------------------------------------------- runner */
  var HANDLERS = { hero: hero, hero3d: hero3d, icono3d: icono3d, symbol: symbol, gallery: gallery, ritual: ritual, timeline: timeline };

  function run(task) {
    if (!task) return;
    var kind = task[0], id = task[1];
    var root = document.getElementById(id);
    if (!root) return;
    revealAll(root);
    var fn = HANDLERS[kind];
    if (fn) { try { fn(root); } catch (e) { console.warn('[pleena] ' + kind, e); } }
  }

  function drain() {
    var q = window.PLEENA_Q || [];
    while (q.length) run(q.shift());
    window.PLEENA_Q = { push: function () { for (var i = 0; i < arguments.length; i++) run(arguments[i]); return 0; }, length: 0 };
  }

  function init() {
    revealAll(document);
    drain();
    bootGsap();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: al recargar una sección hay que re-registrar y refrescar
  document.addEventListener('shopify:section:load', function (e) {
    revealAll(e.target);
    var q = window.PLEENA_Q; if (q && q.length) drain();
    setTimeout(function () { if (window.ScrollTrigger) window.ScrollTrigger.refresh(); }, 60);
  });
  document.addEventListener('shopify:section:unload', function () {
    setTimeout(function () { if (window.ScrollTrigger) window.ScrollTrigger.refresh(); }, 60);
  });

  // red de seguridad: si por lo que sea nada arrancó, se muestra todo
  setTimeout(function () {
    var pend = document.querySelectorAll('[data-preveal]:not([data-preveal-on])');
    if (pend.length > 12) document.documentElement.classList.remove('pl-js');
  }, 4000);
})();
